import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const DELETE_LINE_ITEM_URL = `${CART_URL}/line-items`;

export async function removeLineItem(
  lineItemId: string
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';

  return await httpClient.delete(
    `${DELETE_LINE_ITEM_URL}/${lineItemId}?expand=${expandParam}`
  );
}
